module.exports = __webpack_public_path__ + "img/pj.588ed2ab.png";